/**
 * One filter group in the careers rail, in the dcv2 design language.
 *
 * Selected reads as the inverted chip surface rather than a tinted accent,
 * because the canvas expresses "on" by inversion (capability card 04, the
 * primary button) and has no tinted-fill idiom to borrow.
 */
export function FilterSection({
  title,
  options,
  selected,
  onToggle,
  last = false,
}: {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
  last?: boolean;
}) {
  return (
    <div style={last ? undefined : { marginBottom: 26 }}>
      <h3
        style={{
          margin: "0 0 12px",
          fontFamily: "'Manrope', sans-serif",
          fontSize: 11.5,
          fontWeight: 400,
          letterSpacing: ".16em",
          textTransform: "uppercase",
          color: "var(--link)",
        }}
      >
        {title}
      </h3>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {options.map((opt) => {
          const checked = selected.includes(opt);
          return (
            <button
              key={opt}
              type="button"
              onClick={() => onToggle(opt)}
              aria-pressed={checked}
              className={checked ? undefined : "dc-h-ghost"}
              style={{
                cursor: "pointer",
                fontFamily: "'Manrope', sans-serif",
                fontSize: 12,
                lineHeight: 1.2,
                borderRadius: 999,
                padding: "7px 15px",
                border: checked
                  ? "1px solid var(--chip)"
                  : "1px solid rgba(var(--ink-rgb),.3)",
                background: checked ? "var(--chip)" : "transparent",
                color: checked ? "var(--chipfg)" : "rgba(var(--ink-rgb),.66)",
                transition: "border-color .2s, background .2s, color .2s",
              }}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </div>
  );
}
